import React, { useState } from "react";
import "../../pages/customerMaster/customerMaster.scss";
import Modal from 'react-bootstrap/Modal';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';

const CompanyDocuments = ({
  HandleImageFileChange,
  formValues,
  formErrors,
  DeleteImage,
  showImage,
}) => {
  const [show, setShow] = useState({ show: false, imagePath: "" });
  const handleClose = () => setShow({ show: false, imagePath: "" });
  const handleShow = (imageurl) => setShow({ show: true, imagePath: imageurl });

  return (
    <>
      <div className="row company-document-upload-row">
        <div className="col-lg-3 col-md-4 col-sm-6 col-xs-12">
          <div>
            <form id="file-upload-form" className="uploader">
              <input
                id="file-upload-datasheet-company"
                type="file"
                name="logoUrl"
                size={50}
                accept=".jpg,.png"
                onChange={(e) => { HandleImageFileChange(e, "logoObj"); }}
                onClick={(e) => { e.target.value = null; }}
              />
              {formValues?.logoUrl ? (
                <div class="after-upload-img">
                  <img src={showImage?.logoUrl} />
                  <div class="edit-actions">
                    <div class="d-flex gap-2">
                      <i class="far fa-eye" onClick={() => { handleShow(showImage?.logoUrl) }}></i>
                      <i class="far fa-trash-alt" onClick={() => { DeleteImage("logoUrl"); }}></i>
                    </div>
                  </div>
                </div>
              ) : (
                <label for="file-upload-datasheet-company">
                  <div id="start">
                    <span class="material-symbols-outlined upload-icon">cloud_upload</span>
                    <div className="attach-label">
                      <h6>Upload Company Logo</h6>
                      <p>Only JPG, JPEG, and PNG files with a maximum file size of 1MB</p>
                    </div>
                  </div>
                </label>
              )}
              {formErrors?.logoUrl && <p className="form-error">{formErrors?.logoUrl}</p>}
            </form>
          </div>
        </div>
        <div className="col-lg-3 col-md-4 col-sm-6 col-xs-12">
          <div>
            <form id="file-upload-form" className="uploader">
              <input
                id="file-upload-datasheet-header"
                type="file"
                name="headerUrl"
                size={500000}
                accept=".jpg,.png"
                onChange={(e) => { HandleImageFileChange(e, "headerObj"); }}
                onClick={(e) => { e.target.value = null; }}
              />
              {formValues?.headerUrl ? (
                <div class="after-upload-img">
                  <img src={showImage?.headerUrl} />
                  <div class="edit-actions">
                    <div class="d-flex gap-2">
                      <i class="far fa-eye" onClick={() => { handleShow(showImage?.headerUrl) }}></i>
                      <i class="far fa-trash-alt" onClick={() => { DeleteImage("headerUrl"); }}></i>
                    </div>
                  </div>
                </div>
              ) : (
                <label for="file-upload-datasheet-header">
                  <div id="start">
                    <span class="material-symbols-outlined upload-icon">cloud_upload</span>
                    <div className="attach-label">
                      <h6>Upload Letterpad Header</h6>
                      <p>Only JPG, JPEG, and PNG files with a maximum file size of 1MB</p>
                    </div>
                  </div>
                </label>
              )}
              {formErrors?.headerUrl && <p className="form-error">{formErrors?.headerUrl}</p>}
            </form>
          </div>
        </div>
        <div className="col-lg-3 col-md-4 col-sm-6 col-xs-12">
          <div>
            <form id="file-upload-form" className="uploader">
              <input
                id="file-upload-datasheet-footer"
                type="file"
                name="footerUrl"
                size={500000}
                accept=".jpg,.png"
                onChange={(e) => { HandleImageFileChange(e, "footerObj"); }}
                onClick={(e) => { e.target.value = null; }}
              />
              {formValues?.footerUrl ? (
                <div class="after-upload-img">
                  <img src={showImage?.footerUrl} />
                  <div class="edit-actions">
                    <div class="d-flex gap-2">
                      <i class="far fa-eye" onClick={() => { handleShow(showImage?.footerUrl) }}></i>
                      <i class="far fa-trash-alt" onClick={() => { DeleteImage("footerUrl"); }}></i>
                    </div>
                  </div>
                </div>
              ) : (
                <label for="file-upload-datasheet-footer">
                  <div id="start">
                    <span class="material-symbols-outlined upload-icon">cloud_upload</span>
                    <div className="attach-label">
                      <h6>Upload Letterpad Footer</h6>
                      <p>Only JPG, JPEG, and PNG files with a maximum file size of 1MB</p>
                    </div>
                  </div>
                </label>
              )}
              {formErrors?.footerUrl && <p className="form-error">{formErrors?.footerUrl}</p>}
            </form>
          </div>
        </div>
      </div>

      <Modal show={show?.show} onHide={handleClose} animation={false} size="md" className="imgViewModal"
        aria-labelledby="contained-modal-title-vcenter" centered>
        <Modal.Body>
          <Row>
            <Col lg={12}>
              <div className="text-right pt-3 pb-3">
                <i className="fas fa-times" onClick={handleClose}></i>
              </div>
            </Col>
            <Col lg={12}>
              <div className="text-center">
                <img src={show?.imagePath} alt="Product Image"></img>
              </div>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default CompanyDocuments;